'use client'

import React, { ChangeEvent, useCallback, useEffect } from 'react'
import { useState } from 'react'
import { Listbox } from '@headlessui/react'
import Image from 'next/image'
import selectArrow from '@/assets/img/select-arrow.svg'
import searchIcon from '@/assets/img/search-gradient.svg'
import searchClose from '@/assets/img/catalog-search-close.svg'
import { usePathname } from 'next/navigation'
import { filterTagsNews } from '@/assets/data/filter'
import FilterTags from '@/components/filter/FilterTags'
import sortBtnIcon from '@/assets/img/catalog/catalog-sort-btn-icon.svg'
import { ProductFilter, useFilterProductsMutation } from '@/redux/services/catalogApi'
import { debounce } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { setMaterialsSearch, setNewsSearch, setTitle } from '../../redux/features/filterSlice'
import { RootState } from '../../redux/store'
import { useGetNewsFilterTagsQuery } from '@/redux/services/tagsApi'
import { useTranslation } from 'react-i18next'
import s from './Select.module.scss'
import { MenuItem, Select } from '@mui/material'
import { SelectIcons } from './SelectIcons'
import "./Select.scss"

interface Props {
    curtainOpen?: boolean
    setCurtainOpen?: (state: boolean) => void
    selectList?: string[]
    vacancySpecs?: number[]
    vacancyRegion?: number[]
    vacancySearch?: string
    setVacancySearch?: (str: string) => void
    setSearchValue?: any
    sort?: any
    setSort?: any
}

const Filter: React.FC<Props> = ({
    selectList,
    curtainOpen,
    setCurtainOpen,
    vacancySpecs,
    vacancyRegion,
    vacancySearch,
    setVacancySearch,
    setSearchValue,
    sort,
    setSort
}) => {
    const dispatch = useDispatch()
    const [tags, setTags] = useState([])
    // const [selectedOption, setSelectedOption] = useState(selectList[0])
    const [searchOpen, setSearchOpen] = useState(false)
    const [inputValue, setInputValue] = useState('')
    // const [sort, setSort] = useState('id')
    const { animalType, animalAge, animalNeeds, animalTypesCategory, productType, feedingType, animalPackaging } =
        useSelector((state: RootState) => state.filter)
    const searchRef = React.useRef<HTMLInputElement>(null)
    const pathnameNews = usePathname().includes('/news')
    const pathnameMaterials = usePathname().includes('/useful-materials')
    const { t } = useTranslation()

    const { data: tagsData } = useGetNewsFilterTagsQuery()

    useEffect(() => {
        setTags(tagsData)
    }, [tagsData])

    const inputOpen = () => {
        setSearchOpen(true)
        searchRef.current?.focus()
    }

    const onInputClear = () => {
        setInputValue('')
        setSearchValue('clear')
        // setInputValue('')
        // if (pathnameNews) {
        //     updateNewsSearchValue('')
        // } else if (pathnameMaterials) {
        //     updateMaterialsSearchValue('')
        // } else {
        //     if (vacancySearch) {
        //         updateVacancySearchValue('')
        //     } else {
        //         updateCatalogSearchValue('')
        //     }
        // }
    }

    const updateVacancySearchValue = React.useCallback(
        debounce((str: string) => {
            setVacancySearch(str)
        }, 1500),
        []
    )

    const updateCatalogSearchValue = React.useCallback(
        debounce((str: string) => {
            dispatch(setTitle(str))
        }, 1500),
        []
    )

    const updateNewsSearchValue = React.useCallback(
        debounce((str: string) => {
            dispatch(setNewsSearch(str))
        }, 1500),
        []
    )

    const updateMaterialsSearchValue = React.useCallback(
        debounce((str: string) => {
            dispatch(setMaterialsSearch(str))
        }, 1500),
        []
    )

    const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value)
        if (pathnameNews) {
            updateNewsSearchValue(e.target.value)
        } else if (pathnameMaterials) {
            updateMaterialsSearchValue(e.target.value)
        } else {
            if (vacancySpecs) {
                updateVacancySearchValue(e.target.value)
            } else {
                updateCatalogSearchValue(e.target.value)
            }
        }
    }

    const handleSearchValue = useCallback(
        debounce((e: ChangeEvent<HTMLInputElement>) => {
            if (setSearchValue) {
                setSearchValue(e.target.value)
            }
        }, 1500),
        []
    )

    const totalFilters = vacancySpecs
        ? vacancySpecs?.length + vacancyRegion?.length
        : +animalAge.length +
          animalNeeds.length +
          animalTypesCategory.length +
          productType.length +
          feedingType.length +
          animalPackaging.length

    const toggleCurtain = () => {
        setCurtainOpen(!curtainOpen)
        if (!curtainOpen) {
            document.body.classList.add('no-scroll')
        } else {
            document.body.classList.remove('no-scroll')
        }
    }

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (searchRef.current && !event.composedPath().includes(searchRef.current)) {
                setSearchOpen(false)
            }
        }

        document.body.addEventListener('click', handleClickOutside)
        return () => document.body.removeEventListener('click', handleClickOutside)
    }, [])

    return (
        <div className={searchOpen ? 'filter search_open' : 'filter'}>
            {/* НЕ УБИРАТЬ!!! */}

            {/* {!searchOpen && <div className="filter__select">
                <Listbox value={selectedOption} onChange={setSelectedOption}>
                    {({ open }) => (
                        <>
                            <Listbox.Button className='filter__select-btn'>
                                {selectedOption}
                                <Image className={open ? 'filter__select-img_active' : 'filter__select-img'} src={selectArrow} width={20} height={20} alt='arrow' />
                            </Listbox.Button>
                            {open && (
                                <div>
                                    <Listbox.Options className='filter__select-list' static>
                                        {selectList?.map((item) => (
                                            <Listbox.Option
                                                className={selectedOption.toLowerCase() === item.toLowerCase() ? 'filter__select-option_selected' : 'filter__select-option'}
                                                key={item}
                                                value={item}>
                                                {item}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            )}
                        </>
                    )}
                </Listbox>
            </div>} */}
            {pathnameNews && tags && (
                <FilterTags
                    searchOpen={searchOpen}
                    list={tags}
                />
            )}
            <aside
                ref={searchRef}
                style={!searchOpen ? { position: 'absolute' } : {}}
                className='filter__search-block'
            >
                <div className='filter__search-input-wrapper'>
                    <input
                        style={inputValue.length ? { caretColor: '#FFAC6A' } : { caretColor: '#A9B4D1' }}
                        className={searchOpen ? 'filter__search-input_active' : 'filter__search-input'}
                        type='text'
                        value={inputValue}
                        onChange={e => {
                            onChangeInput(e)
                            handleSearchValue(e)
                        }}
                        placeholder={t('search')}
                    />
                    {searchOpen && inputValue && (
                        <Image
                            className='filter__input-close'
                            onClick={onInputClear}
                            src={searchClose}
                            width={20}
                            height={20}
                            alt='input-close'
                        />
                    )}
                </div>
            </aside>
            <div className={'filter__search ' + s.search}>
                {!searchOpen && (
                    <>
                        {sort && setSort ? (
                            <div
                                className={s.sortHeader}
                                style={sort && setSort ? { display: 'flex' } : { display: 'block' }}
                            >
                                <button
                                    onClick={inputOpen}
                                    className='filter__search-btn'
                                >
                                    <p>{t('search')}</p>
                                    <Image
                                        src={searchIcon}
                                        width={20}
                                        height={20}
                                        alt='search-icon'
                                    />
                                </button>
                                <div className={s.sort}>
                                    {sort && setSort ? (
                                        <>
                                            {/* <select
                                                value={sort}
                                                onChange={e => {
                                                    setSort(e.target.value)
                                                }}
                                                className={s.select}
                                            >
                                                <option value='id'>Сначала новые</option>
                                                <option value='title'>По алфавиту</option>
                                                <option value='views'>По популярности</option>
                                            </select> */}
                                            <Select
                                                value={sort}
                                                onChange={e => {
                                                    setSort(e.target.value)
                                                }}
                                                IconComponent={SelectIcons}
                                                className={s.mui_select}
                                            >
                                                <MenuItem value='id'>Сначала новые</MenuItem>
                                                <MenuItem value='title'>По алфавиту</MenuItem>
                                                <MenuItem value='views'>По популярности</MenuItem>
                                            </Select>
                                            
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        ) : (
                            <button
                                onClick={inputOpen}
                                className='filter__search-btn'
                            >
                                <p>{t('search')}</p>
                                <Image
                                    src={searchIcon}
                                    width={20}
                                    height={20}
                                    alt='search-icon'
                                />
                            </button>
                        )}

                        <div
                            onClick={toggleCurtain}
                            className='catalog__sort-btn'
                        >
                            <div className='catalog__sort-btn-icon'>
                                <Image
                                    src={sortBtnIcon}
                                    width={20}
                                    height={20}
                                    alt='sort-icon'
                                />
                                {!totalFilters ? null : <span className='catalog__sort-btn-count'>{totalFilters}</span>}
                            </div>
                            <p>Фильтры</p>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default Filter
